import React from 'react';
import classnames from 'classnames';
import styles from './dataProductPurchases.module.scss';
import { getTimescaleText } from 'v2/utils/dataProductsUtils';
import { DataProduct } from 'v2/models';
import { Table } from 'react-bootstrap';
import { formatDate } from 'v2/utils/dateUtils';

interface DataProductPurchasesProps {
  dataProduct: DataProduct;
}

const DataProductPurchases = ({ dataProduct }: DataProductPurchasesProps) => {
  return (
    <div>
      {dataProduct.purchases.map((purchase, index) => {
        const rows = [
          {
            label: 'Purchase Date',
            value: purchase.purchase_date
              ? formatDate(purchase.purchase_date, false)
              : null,
          },
          {
            label: 'Renewal Date',
            value: purchase.renewal_date
              ? formatDate(purchase.renewal_date, false)
              : null,
          },
          {
            label: 'Cost',
            value: `${purchase.cost?.toFixed(
              2
            )} ${purchase.currency?.toUpperCase()} ${
              purchase.timescale ? getTimescaleText(purchase.timescale) : ''
            }`,
          },
        ];

        if (purchase.opt_out_date) {
          rows.splice(2, 0, {
            label: 'Opt-out Date',
            value: formatDate(purchase.opt_out_date, false),
          });
        }

        return (
          <div
            data-cy="purchase-details-table-container"
            key={purchase.id}
            data-testid={`purchase_${purchase.id}`}
            className={classnames('mb-4', styles.purchase)}
          >
            <Table className={classnames(styles.table)}>
              <tbody>
                {rows.map((row) => (
                  <tr
                    key={row.label}
                    data-testid={`${index}-${row.label.replaceAll(' ', '')}`}
                  >
                    <td className={styles.label}>{row.label}</td>
                    <td className={styles.value}>{row.value}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div data-testid={`${index}-Note`} data-cy="purchase-note-text">
              {purchase.note || ''}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DataProductPurchases;
